document.addEventListener("DOMContentLoaded", () => {
  const {
    formId,
    desktopImage,
    desktopImageRatio,
    mobileImage,
    mobileImageRatio,
    freeShippingLimit,
  } = window.newsletterPopupForm;

  var bgImageUrl = null;
  var formContainerClasses = null;

  const observer = new MutationObserver((mutations, obs) => {
    const formEmbeds = document.querySelectorAll(
      `shopify-forms-embed#app-embed-container-${formId}`,
    );
    if (formEmbeds.length > 0) {
      formEmbeds.forEach(async (formEmbed) => {
        if (!formEmbed.getAttribute("data-random-uuid")) {
          const uuid = crypto.randomUUID();
          formEmbed.setAttribute("data-random-uuid", "form-embed-" + uuid);

          const appEmbed = formEmbed.shadowRoot.querySelector("#app-embed");
          const style = document.createElement("style");
          let styleContent = `
            :host {
              --container-border-radius: 0 !important;
            }
            * {
              font-family: Inter, sans-serif !important;
              box-sizing: border-box !important;
            }
            // [class*="_formCloseButton_"] {
            //   display: none !important;
            // }
            // section[class*="_formContainer_"]:not(:has(form)) [class*="_formCloseButton_"] {
            //   display: block !important;
            // }
            [class*="_formCloseButton_"] svg {
              fill: var(--SubText) !important;
              height: 14px !important;
              width: 14px !important;
            }
            section[class*="_formContainer_"] {
              --col-size: 400px !important;
              aspect-ratio: 1.65 !important;
              grid-template-columns: repeat(2, 50%) !important;
              width: calc(2 * var(--col-size)) !important;
              max-width: 90% !important;
              min-width: unset !important;
            }
            [class*="_gridItemContent_"] {
              height: fit-content !important;
              margin: auto 0 !important;
              padding-top: 40px !important;
              padding-bottom: 40px !important;
              display: flex !important;
              flex-direction: column !important;
              justify-content: center !important;
              align-items: center !important;
            }
            @media only screen and (max-width: 767px) {
              section[class*="_formContainer_"] {
                aspect-ratio: unset !important;
                grid-template-rows: unset !important;
                grid-template-columns: repeat(2, 100%) !important;
                width: 400px !important; 
              }
              [class*="_gridItem_"][class*="_imageLoaded_"] {
                aspect-ratio: 1.74 !important;
              }
            }
            [class*="_textHeading_"] {
              font-family: baskerville-urw, serif !important;
              font-weight: 400 !important;
              font-size: 24px !important;
              line-height: 120% !important;
              letter-spacing: 4% !important;
              text-align: center !important;
              vertical-align: middle !important;
              margin-bottom: 53px !important;
            }
            [class*="_textBody_"] {
              font-weight: 300 !important;
              font-size: 12px !important;
              line-height: 140% !important;
              letter-spacing: 0% !important;
              text-align: center !important;
              vertical-align: middle !important;
            }  
            section[class*="_formHeader_"] {
              width: 300px !important;
              max-width: 100% !important;
              margin-top: 0 !important;
              margin-bottom: 44px !important;
            }
            form {
              display: flex !important;
              justify-content: center !important;
              align-items: center !important;
              width: 100% !important;
              gap: 6px !important;
            }
            form > *,
            input#email,
            button[type="submit"] {
              width: 100% !important;
              max-width: 285px !important;
            }
            input#email {
              // height: 39px !important;  
              width: 100% !important;
              border-radius: 0 !important;
              padding-top: 0 !important;
              padding-bottom: 0 !important;
              box-shadow: none !important;
              border: 1px solid #989898 !important;
              text-align: center !important;
              vertical-align: middle !important;
              margin: 0 auto !important; 

              font-family: var(--ff) !important;
              font-weight: var(--fwn) !important;
              font-style: normal !important;
              font-size: 13px !important;
              color: var(--Title) !important;
              background: white !important;
              border: 1px solid #9f9f9f !important;
              padding: 10px !important;
            }
            input#email::placeholder {
              display: block !important;
              opacity: 1 !important;
              color: #555555 !important;
            }
            label#label-email {
              display: none !important;
            }
            button[type="submit"] {
              // height: 39px !important; 
              width: 100% !important;
              border-radius: 0 !important;
              padding-top: 0 !important;
              padding-bottom: 0 !important;

              background: #555555 !important;
              border: 1px solid rgb(159, 159, 159) !important;
              border-radius: 0px !important;
              color: #ffffff !important;
              font-size: 13px !important;
              font-weight: normal !important;
              text-align: center !important;
              line-height: 12px !important;
              padding: 12px 20px !important;
              // text-transform: uppercase !important;
            }
            [class*="_formDisclaimer_"] {
              display: none !important;
            }
            .btn-no-thanks {
              background-color: transparent !important;
              border: none !important;
              box-shadow: none !important;
              color: #555555 !important;
              font-weight: 300 !important;
              font-size: 13px !important;
              line-height: 120% !important;
              letter-spacing: 0% !important;
              text-align: center !important;
              vertical-align: middle !important;
              margin-top: 10px !important;
              cursor: pointer !important;
            }
            @media only screen and (max-width: 767px) {
              section[class*="_formContainer_"] {
                max-height: 95vh !important;
              }
              [class*="_textHeading_"] {
                margin-bottom: 36px !important;
                // font-size: 18px !important;
              }
              [class*="_textBody_"] {
                // font-size: 9px !important;
              }
              section[class*="_formHeader_"] {
                margin-bottom: 39px !important;
              }
              input#email,
              button[type="submit"],
              .btn-no-thanks {
                // font-size: 9.75px !important;
              }
            }
          `;

          if (desktopImage) {
            styleContent += `     
              [class*="_gridItem_"][class*="_imageLoaded_"] {
                background-image: url('${desktopImage}') !important;
              }
            `;
          }
          if (mobileImage) {
            styleContent += `     
              @media only screen and (max-width: 767px) {
                [class*="_gridItem_"][class*="_imageLoaded_"] {
                  background-image: url('${mobileImage}') !important;
                  aspect-ratio: ${mobileImageRatio} !important;
                }
              }
            `;
          }

          style.textContent = styleContent;
          appEmbed.appendChild(style);

          const observer2 = new MutationObserver((mutations) => {
            appEmbed.querySelectorAll("p").forEach((p) => {
              if (p.innerHTML.includes("[[newsletter_free_shipping_limit]]")) {
                p.innerHTML = p.innerHTML.replaceAll(
                  "[[newsletter_free_shipping_limit]]",
                  freeShippingLimit,
                );
              }
            });

            const bgImageEl = appEmbed.querySelector(
              '[class*="_gridItem_"][class*="_imageLoaded_"]',
            );
            if (bgImageEl) {
              const bgImage = bgImageEl.style.backgroundImage;
              const match = bgImage.match(/url\(["']?([^"')]+)["']?\)/);
              if (match) {
                bgImageUrl = match[1];
              }
            }

            const formContainerEl = appEmbed.querySelector(
              'section[class*="_formContainer_"]',
            );
            if (formContainerEl) {
              if (formContainerEl.querySelector("form")) {
                formContainerClasses = formContainerEl.classList.toString();
              } else {
                if (
                  bgImageUrl &&
                  !formContainerEl.classList.contains("image-loaded-on-success")
                ) {
                  formContainerEl.setAttribute(
                    "class",
                    formContainerClasses + " image-loaded-on-success",
                  );
                  bgImageEl.style.backgroundImage = `url('${bgImageUrl}')`;
                }
              }
            }

            const form = appEmbed.querySelector("form");
            if (form) {
              const inputEmailEl = form.querySelector("input#email");
              if (
                inputEmailEl &&
                inputEmailEl.getAttribute("placeholder") !== "Email"
              ) {
                inputEmailEl.setAttribute("placeholder", "Email");
              }

              let buttonNoThanks = form.querySelector(".btn-no-thanks");
              if (!buttonNoThanks) {
                buttonNoThanks = document.createElement("button");
                buttonNoThanks.innerHTML = "No thanks";
                buttonNoThanks.classList.add("btn-no-thanks");
                buttonNoThanks.addEventListener("click", () => {
                  const closeButtonEl = appEmbed.querySelector(
                    '[class*="_formCloseButton_"]',
                  );
                  closeButtonEl.click();
                });
                form.appendChild(buttonNoThanks);
              }
            }
          });

          // Observe changes inside the element
          observer2.observe(appEmbed, {
            childList: true, // additions/removals of child nodes
            attributes: true, // attribute changes
            characterData: true, // text content changes
            subtree: true, // watch all descendants, not just targetNode itself
            attributeOldValue: true, // include old attribute value in the record
            characterDataOldValue: true, // include old text value in the record
          });
        }
      });
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
});
